import {
  Branch,
  BranchHours,
  LicenseeType,
  MobileContact,
} from "@/app/types/branch";
import { Factory } from "fishery";

export const mobileContactFactory = Factory.define<MobileContact>(
  ({ sequence }) => ({
    name: `Manager ${sequence}`,
    role: "Branch Manager",
    telephone: "00966500000005",
  }),
);

export const branchHoursFactory = Factory.define<BranchHours>(() => ({
  opensAt: 360,
  closesAt: 240,
}));

export const licenseeFactory = Factory.define<LicenseeType>(({ sequence }) => ({
  id: 1 + sequence - 1,
  code: "FFC",
  name: "Fast Food Company",
  vat: "4000000000",
  commercialRegistration: "500000000",
}));

export const branchFactory = Factory.define<Branch>(({ sequence }) => ({
  id: sequence,
  name: "POSist test lab",
  city: "Jeddah",
  deliveryMethods: ["home_delivery", "offline_drive_thru", "pickup"],
  addressDescription: "Al-Baik BFX POSist lab",
  latitude: 21.5615979,
  longitude: 39.2234012,
  distance: 2.5,
  isOpen: true,
  estimatedWaitingTime: 10,
  openingHours: [branchHoursFactory.build()],
  mobileContacts: [mobileContactFactory.build()],
  licensee: licenseeFactory.build(),
  supportsPickupCustomerArrivalFlow: true,
  hasCustomMenu: true,
  acceptingInStoreOrders: true,
  acceptingCurbsideOrders: true,
  hasCustomPricingForDelivery: false,
  showSosNumberInAlbaikApp: true,
  curbsideExpectedBranchDelayMinutes: 5,
  pickupPreparationTimeStrategy: "basket_total",
}));
